/**
 *
 * PasswordRequirements Component
 *
 */

import React from "react";

import { stylize } from "@envestnet/envreact-component-library";
import classnames from "classnames";
import withIntl from "utils/withIntl";
import { PasswordPoliciesLoader } from "./loaders";
import messages from "./messages";
import styles from "./styles";
import { PasswordRequirementsProps } from "./types";

const PasswordRequirements = (props: PasswordRequirementsProps) => {
  const {
    classes,
    style,
    className,
    innerRef,
    passwordRules,
    loading,
    formatMessage,
  } = props;

  return (
    <div
      ref={innerRef}
      className={classnames(className, classes.container)}
      style={style}
    >
      <div data-testid="password-rules" className={classes.passwordRules}>
        <span className="header-font-family">
          {formatMessage(messages.passwordRequirements)}:
        </span>
        {loading ? (
          <PasswordPoliciesLoader />
        ) : (
          <ul
            className={classnames(
              classes.modalDetailsText,
              "header-font-family"
            )}
          >
            {passwordRules &&
              passwordRules?.passwordPolicyStatements?.map((row) => (
                <li key={row}>{row}</li>
              ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default withIntl(
  stylize<PasswordRequirementsProps>(styles)(PasswordRequirements)
);
